import { ScrapbookFile } from '@/api/scrapbook-data';

interface AnalyticsBuilderSectionItemProps {
  file: ScrapbookFile;
  selected: boolean;
  onSelect: () => void;
  viewMode?: 'grid' | 'list';
}

const AnalyticsBuilderSectionItem: React.FC<AnalyticsBuilderSectionItemProps> = ({ file, selected, onSelect, viewMode = 'grid' }) => {
  if (!file) return null;

  const itemClassName = `item ${selected ? 'sel' : 'unsel'}`;

  if (viewMode === 'list') {
    return (
      <div className="flex h-[160px] cursor-pointer items-center gap-4 border border-gray-200 bg-white">
        <div className="h-full w-[315px] border-r border-gray-300 bg-gray-50 px-[21px] py-0">
          <div className="p-3">{file?.content?.subject}</div>
        </div>
        <div className="relative bottom-10 flex-1">
          <h4 className="font-bold text-gray-900">{file?.content?.displayName}</h4>
          <div className="mt-1 text-xs text-black">
            <div
              className="line-clamp-3 overflow-hidden"
              dangerouslySetInnerHTML={{ __html: file?.content?.description || '' }}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div draggable className="draggable-item">
      <div className={itemClassName}>
        <div className="selTick" onClick={onSelect}></div>
        <div className="cmp">
          <div
            className="cntr relative h-0 w-full cursor-pointer overflow-hidden border border-gray-300 bg-gray-50 pt-[30px]"
            style={{ paddingBottom: '73.25%' }}
          >

            <div className="p-3"><span className="font-bold">{file?.content?.title}</span><br />{file?.content?.reportTitle}</div>
          </div>
          <div className="ifno relative h-[120px] cursor-pointer overflow-hidden border border-t-0 border-gray-300 bg-white p-3 text-sm">
            <div className="reportTitle">
              <h4 className="line-clamp-4 font-bold">{file?.content?.reportDisplayName}</h4>
              <div className="lnk mt-1 text-xs">

                <div
                  className="line-clamp-3 overflow-hidden"
                  dangerouslySetInnerHTML={{ __html: file?.content?.reportDescription || '' }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsBuilderSectionItem;
